import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
const variantMapping = {
    copy1: { width: '150px', height: '24px' },
    copy2: { width: '120px', height: '20px' },
    copy3: { width: '100px', height: '16px' },
    order1: { width: '300px', height: '52px' },
    order2: { width: '250px', height: '44px' },
    order3: { width: '200px', height: '32px' },
    order4: { width: '150px', height: '24px' },
    display1: { width: '500px', height: '84px' },
    display2: { width: '300px', height: '64px' },
};
export const TextSkeleton = (props) => {
    const size = props.variant
        ? variantMapping[props.variant]
        : variantMapping['copy1'];
    const height = `${parseInt(size.height.replace('px', '')) * (props.lines || 1)}px`;
    const width = props.width || size.width;
    return (React.createElement(SkeletonShape, { variant: "rectangular", width: width, height: height, spacing: props.spacing }));
};
//# sourceMappingURL=Text.skeleton.mjs.mjs.map